/* Meltify theme scripts. No dependencies. */
(function () {
  'use strict';

  var body = document.body;

  /* ---------------------------------------------------------------- utils */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function trapFocusIn(container) {
    if (!container) return;
    var focusable = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (focusable.length) focusable[0].focus();
  }

  /* -------------------------------------------------------------- panels  */
  /* Any element with [data-panel-open="ID"] toggles #ID open.              */

  function openPanel(id) {
    var panel = document.getElementById(id);
    if (!panel) return;
    panel.classList.add('is-open');
    panel.removeAttribute('aria-hidden');
    body.classList.add('panel-open');
    trapFocusIn(panel);
  }

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (!$('.panel.is-open')) body.classList.remove('panel-open');
  }

  function closeAllPanels() {
    $$('.panel.is-open').forEach(closePanel);
    body.classList.remove('panel-open');
  }

  function escClose(event) {
    if (event.key === 'Escape') closeAllPanels();
  }

  document.addEventListener('keydown', escClose);

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-panel-open]');
    if (opener) {
      event.preventDefault();
      openPanel(opener.getAttribute('data-panel-open'));
      return;
    }
    var closer = event.target.closest('[data-panel-close]');
    if (closer) {
      event.preventDefault();
      closePanel(closer.closest('.panel'));
      return;
    }
    if (event.target.classList && event.target.classList.contains('panel__overlay')) {
      closePanel(event.target.closest('.panel'));
    }
  });

  /* --------------------------------------------------------- nested menus */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-submenu-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var parent = toggle.closest('.menu-drawer__item');
    if (!parent) return;
    var open = parent.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ------------------------------------------------------ quantity inputs */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-change]');
    if (!button) return;
    event.preventDefault();
    var wrapper = button.closest('[data-qty]');
    var input = wrapper && $('input', wrapper);
    if (!input) return;
    var step = parseInt(button.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    if (max !== null && next > max) next = max;
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------- the cart */

  var cartConfig = window.MeltifyCart || {};

  function sectionsToRender() {
    var list = ['cart-drawer'];
    if (document.getElementById('shopify-section-main-cart')) list.push('main-cart');
    return list;
  }

  function replaceSection(id, html) {
    var target = document.getElementById('shopify-section-' + id);
    if (!target || !html) return;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var fresh = holder.querySelector('#shopify-section-' + id);
    target.innerHTML = fresh ? fresh.innerHTML : holder.innerHTML;
  }

  function syncCartCount() {
    var source = $('[data-cart-count-source]');
    if (!source) return;
    var count = source.getAttribute('data-cart-count-source');
    $$('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.classList.toggle('is-empty', count === '0');
    });
  }

  function applyCartResponse(data) {
    var drawerWasOpen = !!$('#CartDrawer.is-open');

    if (data && data.sections) {
      Object.keys(data.sections).forEach(function (id) {
        replaceSection(id, data.sections[id]);
      });
    }
    if (drawerWasOpen) {
      var drawer = document.getElementById('CartDrawer');
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.removeAttribute('aria-hidden');
        body.classList.add('panel-open');
      }
    }

    syncCartCount();
    document.dispatchEvent(new CustomEvent('meltify:cart:updated'));
  }

  function cartRequest(url, payload) {
    payload.sections = sectionsToRender();
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function showCartError(form, message) {
    if (!form) return;
    var slot = $('[data-cart-error]', form);
    if (!slot) return;
    slot.textContent = message || '';
    slot.hidden = !message;
  }

  /* Add to cart */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (cartConfig.type !== 'drawer') return; /* let the browser post normally */

    event.preventDefault();
    var button = $('[data-add-button]', form);
    var label = button ? $('[data-add-label]', button) : null;
    var originalLabel = label ? label.textContent : '';

    if (button) button.setAttribute('disabled', 'disabled');
    if (label && cartConfig.addingText) label.textContent = cartConfig.addingText;
    showCartError(form, '');

    var formData = new FormData(form);
    var payload = { items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }] };

    /* keep any line item properties the merchant added */
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value) {
        payload.items[0].properties = payload.items[0].properties || {};
        payload.items[0].properties[match[1]] = value;
      }
      if (key === 'selling_plan' && value) payload.items[0].selling_plan = value;
    });

    cartRequest(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', payload)
      .then(function (data) {
        applyCartResponse(data);
        openPanel('CartDrawer');
      })
      .catch(function (error) {
        showCartError(form, (error && error.description) || (error && error.message) || cartConfig.genericError || 'Could not add this item.');
      })
      .finally(function () {
        if (button) button.removeAttribute('disabled');
        if (label) label.textContent = originalLabel;
      });
  });

  /* Change or remove a line */
  function changeLine(line, quantity) {
    body.classList.add('cart-busy');
    return cartRequest(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      line: line,
      quantity: quantity
    })
      .then(applyCartResponse)
      .catch(function () { window.location = '/cart'; })
      .finally(function () { body.classList.remove('cart-busy'); });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeLine(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-cart-quantity'), 10), parseInt(input.value, 10) || 0);
  });

  /* Order note */
  var noteTimer;
  document.addEventListener('input', function (event) {
    var note = event.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  /* ------------------------------------------------------- variant picker */

  function initProductForm(container) {
    var dataTag = $('[data-variants-json]', container);
    if (!dataTag) return;

    var variants;
    try { variants = JSON.parse(dataTag.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput = $('[data-variant-id]', container);
    var button = $('[data-add-button]', container);
    var label = button ? $('[data-add-label]', button) : null;
    var priceSlot = $('[data-price-slot]', container);
    var skuSlot = $('[data-sku-slot]', container);
    var inventorySlot = $('[data-inventory-slot]', container);
    var strings = cartConfig.strings || {};

    function selectedOptions() {
      return $$('[data-option-index]', container)
        .filter(function (node) { return node.type !== 'radio' || node.checked; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (node) { return node.value; });
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (variants[i].options[j] !== options[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function markAvailability(options) {
      $$('[data-option-index]', container).forEach(function (node) {
        var index = parseInt(node.getAttribute('data-option-index'), 10);
        var candidate = options.slice(0, index).concat([node.value]);
        var possible = variants.some(function (variant) {
          if (!variant.available) return false;
          for (var j = 0; j < candidate.length; j++) {
            if (variant.options[j] !== candidate[j]) return false;
          }
          return true;
        });
        var wrapper = node.closest('.option-value') || node;
        wrapper.classList.toggle('is-unavailable', !possible);
        if (node.tagName === 'OPTION') node.classList.toggle('is-unavailable', !possible);
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = findVariant(options);
      markAvailability(options);

      if (!variant) {
        if (button) button.setAttribute('disabled', 'disabled');
        if (label) label.textContent = strings.unavailable || 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (button) {
        if (variant.available) button.removeAttribute('disabled');
        else button.setAttribute('disabled', 'disabled');
      }
      if (label) label.textContent = variant.available ? (strings.addToCart || 'Add to bag') : (strings.soldOut || 'Sold out');

      if (priceSlot && variant.priceHtml) priceSlot.innerHTML = variant.priceHtml;
      if (skuSlot) skuSlot.textContent = variant.sku || '';
      if (inventorySlot) inventorySlot.textContent = variant.inventoryText || '';

      /* show the media tied to this variant */
      if (variant.featured_media_id) selectMedia(container, String(variant.featured_media_id));

      /* keep the URL shareable */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    container.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-index]') || event.target.matches('select[data-option-select]')) update();
    });

    markAvailability(selectedOptions());
  }

  /* ------------------------------------------------------- media gallery */

  function selectMedia(scope, mediaId) {
    var gallery = $('[data-gallery]', scope) || $('[data-gallery]');
    if (!gallery) return;
    var target = $('[data-media-id="' + mediaId + '"]', gallery);
    if (!target) return;

    $$('[data-media-id]', gallery).forEach(function (node) {
      if (node.classList.contains('gallery__thumb')) {
        node.classList.toggle('is-active', node.getAttribute('data-media-id') === mediaId);
      } else {
        var active = node.getAttribute('data-media-id') === mediaId;
        node.hidden = !active;
        var video = node.querySelector('video');
        if (video && !active) video.pause();
      }
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.gallery__thumb');
    if (!thumb) return;
    event.preventDefault();
    selectMedia(thumb.closest('[data-gallery]').parentNode, thumb.getAttribute('data-media-id'));
  });

  /* ------------------------------------------------------------- marquee */

  function duplicateTicker() {
    $$('.track:not([data-cloned])').forEach(function (track) {
      track.setAttribute('data-cloned', 'true');
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ------------------------------------------------------------ sticky bar */

  function initStickyHeader() {
    var header = $('[data-sticky-header]');
    if (!header) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      header.classList.toggle('is-stuck', y > 8);
      last = y;
    }, { passive: true });
  }

  /* ------------------------------------------------------------- startup */

  function init(scope) {
    $$('[data-product-form-container]', scope || document).forEach(initProductForm);
    duplicateTicker();
    syncCartCount();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initStickyHeader();
  });

  /* Re-run when the theme editor swaps a section in */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.id === 'shopify-section-cart-drawer') openPanel('CartDrawer');
  });

  window.Meltify = { openPanel: openPanel, closeAllPanels: closeAllPanels };
})();
